const preloadBlock = document.querySelector('.preloader');
const moleculeGray = document.querySelector('.preloader__molecule--gray');
const moleculeColor = document.querySelector('.preloader__molecule--color');

const preloader = (function() {
    function _setProgress(progress) {
        if (progress === 1) {
            preloadBlock.classList.add('hide');
            // TODO: дестрой прелоадера
            return;
        }
        moleculeGray.setAttribute('style', `width: ${100 - progress * 100}%;`);
        moleculeColor.setAttribute('style', `width: ${progress * 100}%;`);
    }
    function update(progress) {
        _setProgress(progress);
    }
    function show() {
        preloadBlock.classList.remove('hide');
    }
    return {
        update: update,
        show: show
    };
})();
export default preloader;
